import { gql } from '@apollo/client/core'

/**
 * Deliberately not reusing the DraftLogicClauseProposition fragment in questionLogic.ts: that one covers the
 * questionnaire/matrix proposition variants and omits the audience one, and two fragments of the same name on
 * the same type cannot coexist in one document. A screening rule only ever holds audience propositions.
 *
 * propositionRef is not selected — the backend regenerates clause/proposition refs on every save.
 */
const SCREENING_RULE = gql`
  fragment ScreeningRule on DraftScreeningRule {
    condition {
      negated
      proposition {
        ... on DraftAudienceReponseOption {
          surveyId
          questionId
          responseOptionId
        }
      }
    }
  }
`

export default SCREENING_RULE
